import React, { Suspense } from 'react';
import { IconPaths } from './imports';
import { useIntl, defineMessages } from 'react-intl-next';
var Icon = function Icon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    glyph = _ref.glyph;
  var Component = IconPaths[glyph];
  var intl = useIntl();
  if (!Component) {
    return null;
  } // do nothing

  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  },
  /*#__PURE__*/
  // @ts-ignore Jira only - TS2322: Type '{ label: string; size: "small" | "medium" | "large"; }' is not assignable to type 'IntrinsicAttributes'.
  React.createElement(Component, {
    label: intl.formatMessage(messages.icon),
    size: size
  }));
};
export default Icon;
export function IconFn(_ref2) {
  var props = _ref2.props;
  var _ref3 = props,
    glyph = _ref3.glyph,
    size = _ref3.size;
  return /*#__PURE__*/React.createElement(Icon, {
    glyph: glyph,
    size: size
  });
}
var messages = defineMessages({
  icon: {
    id: 'confluence.icon.label',
    defaultMessage: 'Icon',
    description: 'A label identifying this component as an icon.'
  }
});